import NextImage from "@components/NextImage";
import React, {PropsWithChildren} from "react";
import {testColors} from "src/constants/Reason/getCareDiscoveryColorScheme";

import styles from "../stylesheets/grid.module.scss";

const PageContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = "",
  ...props
}) => <div className={`flex flex-col items-center  ${className}`} {...props} />;

// eslint-disable-next-line react/display-name
const InnerContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({className = "", ...props}, ref) => (
    <div ref={ref} className={`lg:px-8 px-4 maxw42 w-full ${className}`} {...props} />
  ),
);

export const Faq: React.FC<PropsWithChildren<{backgroundColor: string; patternSrc: string}>> = ({
  backgroundColor,
  patternSrc,
  children,
}) => (
  <PageContainer className="lg:pb-20 pb-0" style={{gridArea: "faq1", backgroundColor}}>
    <div className="relative mt-20 minh16 w-full hidden lg:block">
      <NextImage layout="fill" src={`/patterns/${patternSrc}`} alt="" priority />
    </div>
    <InnerContainer className="lg:mt-16 md:mt-20 mt-20">{children}</InnerContainer>
  </PageContainer>
);

export const Action: React.FC<
  PropsWithChildren<{
    hideGutters?: boolean;
  }>
> = ({children, hideGutters}) => (
  <PageContainer className="bg-gray-50 pb-1" style={{gridArea: "book"}}>
    <InnerContainer className={`h-full py-4 ${hideGutters ? "!ph-0" : ""}`}>
      <div className="lg:sticky lg:top-36">{children}</div>
    </InnerContainer>
  </PageContainer>
);

export const Insurances: React.FC<PropsWithChildren<unknown>> = ({children}) => (
  <PageContainer style={{gridArea: "ins", backgroundColor: testColors.darkBlue}}>
    <InnerContainer className="lg:pt-20 pb-10 pt-10">{children}</InnerContainer>
  </PageContainer>
);

export const GlobalFaq: React.FC<PropsWithChildren<unknown>> = ({children}) => (
  <PageContainer style={{gridArea: "faq2"}}>
    <InnerContainer>{children}</InnerContainer>
  </PageContainer>
);

export const Grid: React.FC<PropsWithChildren<unknown>> = ({children}) => (
  <>
    <div className={`${styles.grid} grid justify-center border-b border-solid border-gray-100`}>
      {children}
    </div>
  </>
);
